// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_-k5","cls2":"common-cls2_KLf common-cls1_-k5","altLook":"common-altLook_vco"};